module.exports = __webpack_public_path__ + "files/dde897d5dda9d16c0c75efd2f3322dde.png";